import React from "react";

function About() {
    return (
        <div class="uk-container uk-padding">
            <img class="uk-visible@m" src="/moin.webp" alt="Moin" width="16% !important" />
            <img class="uk-hidden@m" src="/moin.webp" alt="Moin" width="34% !important" />
            <div class="uk-text-left">
                <p>Mein Name ist <b>Andrea</b> und ich bin Künstlerin, Handwerkerin, Seminar- und Kursleiterin. Ich möchte Euch von meiner Leidenschaft erzählen: von Kreativität und Kunst. Beides begleitet mich seit frühester Kindheit und in nahezu allen Lebenslagen.</p>
                <p>Immer wieder spüre ich, wie mich das Experimentieren mit und Zusammenfügen von
    unterschiedlichen Materialien wie Ton, Beton, Metall, Holz, Draht, Pappmaschee, Farben, Filz, Textil
    uvm. und der damit verbundene kreative Prozess begeistern und gleichzeitig erden. Ich merke, wie
    mein Verstand zur Ruhe kommt und sich ganz auf das Hier und Jetzt konzentriert. Dabei finde ich
    Inspiration in den Materialien, folge meiner Intuition und lasse mich davon begeistern, was meine
    Hände kreieren und erschaffen.</p>
                <h4>Und genau diese Erfahrung möchte ich weitergeben.</h4>
                <p>Die Arbeit als Ergo- und Kunsttherapeutin mit traumatisierten Kindern in der Kinder- und Jugendhilfe
    hat mich immer wieder fasziniert, wie Kunst und Kreativität die Verarbeitung von Erlebtem
    unterstützen und Heilung und Entwicklung stattfinden kann.</p>
                <p>Aktuell widme ich mich ganz meiner eigenen kreativen und künstlerischen Seite, genieße es schöne
    Dinge, überwiegend aus Ton, alten Textilien, Fundstücken und dem, was mich gerade anspricht,
    herzustellen und meiner Experimentierfreude freien Lauf zu lassen.</p>
            <br></br>
            </div>
            <img class="uk-visible@m" src="/andrea.jpeg" alt="andrea" width="30% !important" /> 
            <img class="uk-hidden@m" src="/andrea.jpeg" alt="andrea" width="64% !important" />
            <div class="uk-text-left">
                <br></br>
            <h4>Ein paar Stationen meines Lebens in chronologischer Reihenfoge</h4>
            <ul>
                <li>Arzthelferin mit Qualifizierung zur Medizinisch-technischen Radiologieassistentin</li>
                <li><b>Ergotherapeutin</b>, Tätigkeit in ergotherapeutischen Praxen</li>
                <li>Unternehmensgründung “Atelier Kunterbunt” in Oldenburg im Jahr 2004, mit dem
Schwerpunkt Kreativitätsförderung mit einem reichhaltigen Kursprogramm für Kinder und
Erwachsene; Fortbildungen für Ergotherapeuten im Bereich künstlerisches und kreatives
Gestalten mit unterschiedlichen Materialien in der Therapie; Lehrerfortbildungen im Bereich 
 <b> Kreativitätsförderung.</b></li>
                <li><b>Dozentinnentätigkeit</b> an der Kunstschule Klex, der Kunstschule Brake, in verschiedenen
Jugendeinrichtungen, an der VHS Ammerland und in der Katholischen Erwachsenenbildung</li>
                <li><b>Unternehmensgründung</b> “Entwicklungsbegleitung für Kinder &amp; Eltern” im Jahr 2014. Was
benötigen Kinder, um ihr Potenzial zu entfalten, welche Konflikte und Situationen stören die
Beziehung, wie können elterliche Bedürfnisse gegenüber dem Kind vermittelt werden, wie
kann belastenden Situationen mit einer anderen Haltung begegnet werden.</li>
                <li>Ausbildung in <b>Gewaltfreie Kommunikation</b> nach M. Rosenberg,</li>
                <li>Fortbildungskurse für Tagesmütter an der VHS Ammerland</li>
                <li>Systemische Familienberaterin (VHS)</li>
                <li>Von 2017 bis 2021 Arbeit als <b>Ergo- und Kunsttherapeutin</b> in einer Heilpädagogischen Kinder-
u. Jugendhilfe</li>
                <li>Fortlaufend eigene Weiter- und Fortbildungen in <b>Kunst-, Trauma - und Gestaltungstherapie,</b> sowie zum Thema 
kindliche Entwicklung</li>
            </ul>
            </div>
            
        </div>
    );
}

export default About;